import { Component, Injector, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import {
  CrudComAbasComponent,
  Widget,
} from "src/app/@layout/template-padrao/crud-com-abas/crud-com-abas.component";
import { AuthService } from "src/app/services/auth/auth.service";
import { ComplementoFaturaCteModel } from "./complemento-fatura-cte.model";
import { ComplementoFaturaCteGridPesquisaComponent } from "./complemento-fatura-cte-grid-pesquisa/complemento-fatura-cte-grid-pesquisa.component";
import { ComplementoFaturaCteFiltroPesquisaComponent } from "./complemento-fatura-cte-filtro-pesquisa/complemento-fatura-cte-filtro-pesquisa.component";
import { HttpErrorResponse } from "@angular/common/http";
import { CadastroComplementoFaturaCte } from "./cadastro-complemento-fatura-cte/cadastro-complemento-fatura-cte.component";

import { MatTabGroup } from '@angular/material/tabs';
import { ViewChild } from '@angular/core';
import { ComplementoFaturaCteService } from "src/app/services/complemento-fatura-cte/complemento-fatura-cte.service";

@Component({
  selector: "app-complemento-fatura-cte",
  templateUrl: "../../../../@layout/template-padrao/crud-com-abas/crud-com-abas.component.html",
  styleUrls: ["../../../../@layout/template-padrao/crud-com-abas/crud-com-abas.component.scss"],
})
export class ComplementoFaturaCteComponent
  extends CrudComAbasComponent<ComplementoFaturaCteModel>
  implements OnInit
{
  @Input() override featureId: string;
  public habilitarEditacao: boolean = true;
  public habilitarInclusao: boolean = true;
  override exibeBotaoNovo: boolean = true;
  public componenteFiltro: Widget;
  public componenteGrid: Widget;

  @ViewChild('tabGroup') tabGroup: MatTabGroup;

  alterar() {}

  novo() {
    this.addTabCadastro(
      CadastroComplementoFaturaCte,
      {
        featureId: this.featureId,
        perm: true,
      },
      {},
      `novo_cadastro`,
      "Novo Complemento"
    );
  }

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  gerarArquivoRelatorio(data: any, filename: string, type: string) {
    const arrBuffer = this.base64ToArrayBuffer(data);
    const blob = new Blob([arrBuffer], {
      type,
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  download(data: ComplementoFaturaCteModel) {
    const obj = {
      faturaLoteId: data.faturaLoteId,
      tipoFatura: data.tipoFatura
    }
    this.service.exportarRelatorio(obj).toPromise().then((response: any) => {
      if(!response.retorno) {
        return this.openSnackBar('Nenhum registro encontrado.', 'OK', 5000, 'alert-snackbar');
      } else {
        this.gerarArquivoRelatorio(
          response.retorno.fileContents,
          response.retorno.fileDownloadName,
          response.retorno.contentType
        );
      }
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.openSnackBar('Erro ao carregar relatório, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  public titulo: string = "Complemento da Fatura CT-e";
  public subtitulo: string = "Selecione os filtros para realizar a pesquisa";

  formPesquisa = new FormGroup({
    dataInicio: new FormControl(""),
    dataFim: new FormControl(""),
    clienteId: new FormControl(""),
    tipoStatus: new FormControl(""),
    tipoFatura: new FormControl(""),
  });

  constructor(
    public override injectorObj: Injector,
    public router: Router,
    public authService: AuthService,
    public override service: ComplementoFaturaCteService,
    public dialog: MatDialog
  ) {
    super(injectorObj, service);
    this.setFilterComponent(ComplementoFaturaCteFiltroPesquisaComponent);
    this.setGridComponent(ComplementoFaturaCteGridPesquisaComponent);
  }

  override ngOnInit() {
    this.featureId = "gestao.cte.complemento-fatura-cte";
    this.authService
      .checkFeature(`${this.featureId}.novo`)
      .subscribe((temPermissao) => {
        if (temPermissao === true) this.habilitarInclusao = true;
      });
  }

  public override onSave(tabItem: Widget, response: any): void {
    super.onSave(tabItem, response);
  }
}
